import { PageableArgs, Sorter } from './types';

export function buildPageableParams<P extends string = string>(args: PageableArgs<P> = {}) {
  const {
    projection = 'DEFAULT',
    page = 0,
    size = 20,
    sorters = [],
    filters = {},
  } = args;

  const params = new URLSearchParams({
    projection,
    page: `${page}`,
    size: `${size}`,
  });

  sorters.forEach(({ field, direction }: Sorter) => {
    params.append('sort', `${field},${direction}`);
  });

  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;

    params.set(key, `${value}`);
  });

  return params;
}
